import axios from 'axios';
import { useEffect, useState } from 'react';
import Pagination from 'react-js-pagination';
import { allowScroll, preventScroll } from '../../common/utils';
import '../../../scss/sub/_bookmark.scss';
import HubBookmarkCommodityModal from './HubBookmarkCommodityModal';
import { AnimatePresence } from 'framer-motion';

const HubBookmarkModal = (props) => {
	const [Bookmark, setBookmark] = useState('');
	const [ModalData, setModalData] = useState();
	const [IsBookmarkModalOpen, setIsBookmarkModalOpen] = useState(false);
	const [BookmarkList, setBookmarkList] = useState([]);
	const [CheckedList, setCheckedList] = useState([]);
	const [Table1IsAllCheck, setTable1IsAllCheck] = useState(false);
	const [Page, setPage] = useState(1); // 현재 페이지 번호
	const [BookmarkPage, setBookmarkPage] = useState(1); // 현재 페이지 번호
	const PostPerPage = 10; // 페이지 당 게시글 개수
	const indexOfLastPost = Page * PostPerPage;
	const indexOfFirstPost = indexOfLastPost - PostPerPage;
	const indexOfBookmarkLastPost = BookmarkPage * PostPerPage;
	const indexOfBookmarkFirstPost = indexOfBookmarkLastPost - PostPerPage;

	const handlePageChange = (page, type) => {
		if (type === 'commodity') {
			if (Page !== page) {
				return setPage(page);
			}
		} else if (type === 'bookmark') {
			if (Page !== page) {
				return setBookmarkPage(page);
			}
		}
	};
	const handleInputChange = (e) => {
		e.preventDefault();
		let newValue = e.target.value;
		setBookmark(newValue);
	};
	const handleBookmarkRegist = (e) => {
		console.log('등록할 북마크 값', Bookmark);
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/regBookmark`,
			data: {
				token: localStorage.getItem('token'),
				title: Bookmark,
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				fetchData();
			})
			.catch(function (error) {
				console.log(error);
			});
	};
	const handleBookmarkCommodityOpen = (item) => {
		setModalData(item);
		setIsBookmarkModalOpen((prev) => !prev);
	};
	const handleCheckAllBookmark = (e) => {
		const checkedArray = BookmarkList?.slice(indexOfBookmarkFirstPost, indexOfBookmarkLastPost);
		if (e.target.checked) {
			let newArray = [];
			newArray = CheckedList.concat(checkedArray);
			newArray = newArray.filter((value, index, self) => self.indexOf(value) === index);
			setCheckedList(newArray);
		} else {
			let newArray = CheckedList.filter((item) => !checkedArray.some((obj) => obj.idx === item.idx));
			setCheckedList(newArray);
		}
	};
	const handleCheckedBookmark = (e) => {
		const newValue = JSON.parse(e.target.value);
		let newCheckedList = [];
		if (e.target.checked) {
			newCheckedList = [...CheckedList, newValue];
		}
		setCheckedList(newCheckedList);
	};

	const handleBookmarkDelete = (e) => {
		console.log('해당 북마크 삭제', CheckedList);
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`선택한 북마크를 삭제 하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/deleteBookmark`,
				data: {
					token: localStorage.getItem('token'),
					idx: CheckedList.map(m => m.idx),
				},
				xhrFields: {
					withCredentials: true,
				},
			})
				.then((res) => {
					fetchData();
					setBookmarkPage(1);
					setCheckedList([]);
				})
				.catch(function (error) {
					console.log(error);
				});
		}
	};

	const handleBookmarking = (e) => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`선택된 북마크에 상품들을 등록 하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			//TODO::등록 완료 후 fetch({ ...getBookmark
			const productNos = props['data-productNo'];
			console.log(CheckedList);
			axios({
				method: 'POST',
				url: `${window.location.protocol}//${window.location.hostname}:3001/putBookmark`,
				data: {
					token: localStorage.getItem('token'),
					idx: CheckedList.map(m => m.idx),
					value: productNos
				},
				xhrFields: {
					withCredentials: true,
				},
			})
				.then((res) => {
					props.getBookmarkModalOpen(false);
				})
				.catch();
		}
	};
	useEffect(() => {
		const nowTableIdxArray = BookmarkList?.slice(indexOfBookmarkFirstPost, indexOfBookmarkLastPost).map((el) => Number(el.idx));
		const nowPageChecked = nowTableIdxArray.filter((idx) => CheckedList.some((item) => item.idx === idx));
		if (nowTableIdxArray.length === nowPageChecked.length && BookmarkList.length) {
			setTable1IsAllCheck(true);
		} else {
			setTable1IsAllCheck(false);
		}
	}, [BookmarkList, BookmarkPage, CheckedList]);

	const fetchData = async () => {
		axios({
			method: 'POST',
			url: `${window.location.protocol}//${window.location.hostname}:3001/getBookmark`,
			data: {
				token: localStorage.getItem('token'),
			},
			xhrFields: {
				withCredentials: true,
			},
		})
			.then((res) => {
				setBookmarkList(res.data || []);
			})
			.catch();
	};
	useEffect(() => {
		fetchData();
		const prevScrollY = preventScroll();
		return () => {
			allowScroll(prevScrollY);
		};
	}, []);

	return (
		<div className='modal'>
			<div className='overlay' onClick={() => props.getBookmarkModalOpen(false)}></div>
			<div className='bookmark-modal-content'>
				<div className='modal-header'>
					<h2>북마크 폴더트리</h2>
				</div>
				<button className='close-modal' onClick={() => props.getBookmarkModalOpen(false)}></button>
				<div className='modal-body'>
					<div className='commodity-table'>
						<div className='table-top'>
							<div className='table-top-left'>
								<p>{`선택된 상품목록 총 ${props['data-productNo'].length}개`}</p>
							</div>
						</div>
						<div className='data-table' style={{}}>
							<table>
								<thead>
									<tr>
										<th>No.</th>
										<th>상품 이름</th>
									</tr>
								</thead>
								<tbody>
									{props['data-name']?.slice(indexOfFirstPost, indexOfLastPost).map((item, index) => (
										<tr key={index}>
											<td>{index + 1}</td>
											<td>{item}</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<Pagination
							activePage={Page}
							itemsCountPerPage={Number(PostPerPage)}
							totalItemsCount={props['data-productNo'].length}
							pageRangeDisplayed={10}
							prevPageText={'‹'}
							nextPageText={'›'}
							onChange={(e) => handlePageChange(e, 'commodity')}
						/>
					</div>
					<div className='bookmarkRegist'>
						<p style={{ marginBottom: 10 }}>북마크 등록</p>
						<div className='input'>
							<input type='text' value={Bookmark || ''} onChange={handleInputChange} />
							<button onClick={(e) => handleBookmarkRegist(e)} disabled={Bookmark?.trim().length === 0}>
								북마크 등록
							</button>
						</div>
					</div>
					<div className='bookmark-table'>
						<div className='table-top'>
							<div className='table-top-left'>
								<p>{`목록 총 ${BookmarkList.length}개`}</p>
							</div>
							<div className='table-top-right'>
								<button onClick={handleBookmarkDelete} style={{ marginLeft: '10px' }}>
									선택한 북마크 삭제
								</button>
							</div>
						</div>
						<div className='data-table' style={{}}>
							<table>
								<thead>
									<tr>
										<th>
											<input type='checkbox' checked={Table1IsAllCheck} onChange={(e) => handleCheckAllBookmark(e)} />
										</th>
										<th>idx</th>
										<th>북마크</th>
									</tr>
								</thead>
								<tbody>
									{BookmarkList?.slice(indexOfBookmarkFirstPost, indexOfBookmarkLastPost).map((item, index) => (
										<tr key={index}>
											{/* 선택 */}
											<td>
												<input
													type='checkbox'
													value={JSON.stringify(item)}
													checked={CheckedList.some((obj) => obj.idx === item.idx)}
													onChange={(e) => {
														handleCheckedBookmark(e);
													}}
												/>
											</td>
											{/**북마크*/}
											<td>{item.idx}</td>
											{/**북마크*/}
											<td>
												<span className='clickTd' onClick={() => handleBookmarkCommodityOpen(item)}>
													{item.title}
												</span>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						<Pagination
							activePage={BookmarkPage}
							itemsCountPerPage={Number(PostPerPage)}
							totalItemsCount={BookmarkList.length}
							pageRangeDisplayed={10}
							prevPageText={'‹'}
							nextPageText={'›'}
							onChange={(e) => handlePageChange(e, 'bookmark')}
						/>
						{props['data-productNo'].length > 0 && CheckedList && CheckedList.length > 0 && (
							<div className='bookmarkRegistButton'>
								<button onClick={handleBookmarking}>등록버튼</button>
							</div>
						)}
					</div>
				</div>
			</div>
			<AnimatePresence>
				{IsBookmarkModalOpen && <HubBookmarkCommodityModal bookmarkData={ModalData} getIsBookmarkModalOpen={setIsBookmarkModalOpen} />}
			</AnimatePresence>
		</div>
	);
};

export default HubBookmarkModal;
